<template>
  <div id="preview" class="payment-dialog-wrapper">
    <!-- Modern Dialog Card -->
    <v-card elevation="24" class="payment-dialog-card">
      <!-- Header with Icon and Title -->
      <div class="dialog-header">
        <div class="header-gradient">
          <v-row align="center" justify="space-between" class="pa-4">
            <v-col cols="auto">
              <div class="d-flex align-center">
                <div class="header-icon-circle mr-4">
                  <v-icon size="36" color="white">mdi-credit-card-plus</v-icon>
                </div>
                <div>
                  <h2 class="text-h5 font-weight-bold white--text mb-0">{{ pageDescription }}</h2>
                  <p class="text-caption white--text mb-0 mt-1">
                    <v-icon size="12" color="white" class="mr-1">mdi-information-outline</v-icon>
                    Add a new payment transaction
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="auto">
              <!-- Close Button on Top Right -->
              <v-btn
                @click="closePrompt"
                icon
                small
                color="white"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Form Content -->
      <v-form ref="form1" v-model="valid1" lazy-validation>
        <v-card-text class="pa-6">
          <!-- Payment ID Field -->
          <div class="mb-6">
            <div class="field-label mb-3">
              <v-icon color="primary" size="20" class="mr-2">mdi-credit-card-multiple</v-icon>
              <span class="font-weight-bold">Payment ID <span class="text-danger">*</span></span>
            </div>
            <v-text-field
              v-model="PaymentId"
              :rules="PaymentIdRules"
              placeholder="Enter razorpay payment ID"
              hint="Example: pay_1234567890abcd"
              persistent-hint
              required
              dense
              outlined
              class="payment-input"
              prepend-inner-icon="mdi-identifier"
              clearable
            ></v-text-field>
          </div>

          <!-- Info Alert -->
          <v-alert
            type="info"
            dense
            outlined
            icon="mdi-lightbulb-outline"
            class="info-box"
          >
            <strong>💡 Tip:</strong> Find your Razorpay Payment ID in your payment confirmation email or Razorpay dashboard.
          </v-alert>
        </v-card-text>

        <!-- Action Buttons Footer -->
        <v-card-actions class="pa-6 pt-0 d-flex justify-end gap-3">
          <v-btn
            @click="closePrompt"
            elevation="6"
            large
            rounded
            color="error"
            class="action-btn white--text px-8"
          >
            <v-icon left size="20">mdi-close-circle</v-icon>
            CLOSE
          </v-btn>
          <v-btn
            :disabled="!valid1"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            elevation="6"
            large
            rounded
            color="success"
            class="action-btn white--text px-8"
          >
            <v-icon left size="20">mdi-check-circle</v-icon>
            SAVE
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      rows: [],

      PaymentId: "",
      PaymentIdRules: [(v) => !!v || "Payment ID is required"],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt");
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      //   validate1 = false;

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/program/member/add-online-payment";
        var upload = {
          UserInterface: 1,
          PaymentId: this.PaymentId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.resetForm();
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        thisIns.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.payment-dialog-wrapper {
  padding: 20px;
  background: transparent;
}

/* ============================================
   DIALOG CARD
   ============================================ */
.payment-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  animation: slideInDialog 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ============================================
   HEADER SECTION
   ============================================ */
.dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
    animation: rotate 25s linear infinite;
  }
}

.header-gradient {
  position: relative;
  z-index: 1;
}

.header-icon-circle {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  animation: float 3s ease-in-out infinite;
}

.close-btn {
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.2) !important;
  
  &:hover {
    background: rgba(255, 255, 255, 0.35) !important;
    transform: scale(1.1) rotate(90deg);
  }
}

/* ============================================
   FORM CONTENT
   ============================================ */
.field-label {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #004e92;

  .text-danger {
    color: #ff6b6b;
    margin-left: 4px;
  }
}

.payment-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    border: 2px solid #e0e0e0 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(245, 247, 250, 0.9) 100%);

    &:hover {
      border-color: #667eea !important;
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
    }
  }

  ::v-deep &.v-input--is-focused .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
    background: linear-gradient(135deg, #ffffff 0%, rgba(245, 247, 250, 0.95) 100%);
  }

  ::v-deep .v-input__prepend-inner {
    margin-top: 8px !important;
  }

  ::v-deep .v-label {
    color: #666 !important;
  }

  ::v-deep input::placeholder {
    color: #999;
  }
}

.info-box {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(33, 150, 243, 0.04) 100%) !important;
  border-left: 4px solid #2196f3 !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  animation: slideInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  ::v-deep .v-alert__content {
    font-size: 13px;
    color: #1565c0;
    line-height: 1.6;
  }
}

/* ============================================
   ACTION BUTTONS
   ============================================ */
.action-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    transition: left 0.3s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25) !important;

    &::before {
      left: 100%;
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.gap-3 {
  gap: 12px;
}

.text-danger {
  color: #d32f2f;
}

/* ============================================
   ANIMATIONS
   ============================================ */
@keyframes slideInDialog {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 600px) {
  .payment-dialog-card {
    margin: 0;
    border-radius: 12px !important;
  }

  .action-btn {
    width: 100%;
    margin-bottom: 8px !important;
  }
}
</style>
